import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class SeoLinkValueObject extends ValueObject {
  #href
  #rel

  constructor({href, rel}) {
    super()
    this.#href = href
    this.#rel = rel
  }

  static validate({href, rel}) {
    if (!href) throw InvalidParamsSharedError.create('[SeoLinkValueObject] href is required')
    if (!rel) throw InvalidParamsSharedError.create('[SeoLinkValueObject] rel is required')
  }

  static create({href, rel}) {
    SeoLinkValueObject.validate({href, rel})
    return new SeoLinkValueObject({href, rel})
  }

  get href() {
    return this.#href
  }

  get rel() {
    return this.#rel
  }

  get value() {
    return {
      href: this.#href,
      rel: this.#rel
    }
  }
}
